import React from 'react'
import "./search.css"
import bookdata from './bookdata'

const Books = (props) => {
  
  const booka=props.bk;
  return (
    <>
    <div><h1 style={{ textAlign: "center" }}>{props.subject}</h1></div>
    <section className="main-section">

    {booka.map((book) =>{
            return(
              <div className="card">
              <img
                className="image"
                src={book.img}
                alt=""
              />
              <h5 style={{ textAlign: "center",padding:10 }}>
                {book.title}
              </h5>
              <h6 style={{ textAlign: "center" }}>
                {book.author}
              </h6>
            </div>
                  )
                }
  )
              }
  
  
              

    
    
    
  </section>
  </>
    
  )
}

export default Books